import React from 'react';
import ShipTogetherName from '../../../../../components/order-alerts/ship-together/ship-together-name';
import get from 'lodash.get';

export default {
  id: 'ship-together-name',
  render: (alert) => (
    <ShipTogetherName
      allowForDigitCount={alert.allowForDigitCount}
      count={get(alert, 'fulfillmentPlanIds.length')}
      name={alert.customerName}
    />
  ),
};
